import React from 'react';
import ReactDOM from 'react-dom';
import { FormControl, FormGroup, ControlLabel, Modal } from 'react-bootstrap';
import _ from 'underscore';
import xtend from 'xtend';

class TicketModal extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            validation: {
                'ticketTitle': false,
                'ticketDescription': false
            }
        }
    }

    shouldComponentUpdate (nextProps, nextState) {
        return !_.isEqual(this.state.validation, nextState.validation);
    }

    handleSubmit (ev) {
        ev.preventDefault();
        var data = {};
        [
            'ticketDescription', 'ticketTitle', 'ticketPriority', 'ticketType'
        ].map(function (input) {
            data[input] = ReactDOM.findDOMNode(this.refs[input]).value;
        }, this);

        this.props.onSubmit(data);
        this.props.onClose();
    }

    handleClose (ev) {
        ev.preventDefault();
        this.props.onClose();
    }

    checkValid (ev) {
        if (this.state.validation[ev.target.name] === undefined) return;
        var v = {};
        v[ev.target.name] = !!ev.target.value.length;
        this.setState({
            validation: xtend(this.state.validation, v)
        });
    }

    render () {
        var props = this.props;
        var isValid = _.every(this.state.validation);

        return (<Modal show={true} onHide={this.handleClose}>
            <form onChange={this.checkValid} onSubmit={this.handleSubmit}>
                <Modal.Header>
                    Contact
                </Modal.Header>

                <Modal.Body>
                    <FormGroup>
                        <ControlLabel>Subject</ControlLabel>
                        <FormControl ref="ticketTitle" name="ticketTitle" type="text" />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Description</ControlLabel>
                        <FormControl ref="ticketDescription" name="ticketDescription" type="textarea"
                            componentClass="textarea"
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Type</ControlLabel>
                        <FormControl ref="ticketType" defaultValue={'question'} name="ticketType"
                            componentClass="select"
                        >
                            <option value="question">Question</option>
                            <option value="bug">Bug report</option>
                            <option value="feature">Feature request</option>
                        </FormControl>
                    </FormGroup>
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-link" onClick={this.handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary"
                        disabled={!isValid}
                        type="submit">
                            Submit
                    </button>
                </Modal.Footer>


                <input ref="ticketPriority" type="hidden"
                    name="ticketPriority" value="1"
                />
            </form>
        </Modal>);
    }
}

export default TicketModal;
